"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUSE_VERSION_STRING = exports.APPSDK_JS = exports.UA_FLAG = void 0;
// 通过判断navigator.userAgent中的特殊字符来区分内嵌不同的app
exports.UA_FLAG = {
    wuba: "58app",
    wbutown: "58town" // 内嵌同镇本地版
};
exports.APPSDK_JS = {
    "58app": "//a.58cdn.com.cn/app58/rms/app/js/app_30805.js",
    "58town": "//j1.58cdn.com.cn/weixin/js/r/wbutownSdk.min.js"
};
// 同镇整合暂定12.0.0版本  测试包版本号为12.0.0
exports.FUSE_VERSION_STRING = '12.0.0';
